/* eslint-disable no-shadow */

const initialState = {
  modalContext: {
    modalBeingShown: '',
    auctionId: null,
    moduleKey: '',
    originPoint: '',
    additionalProperties: {},
  },
};

export const state = { ...initialState };

export const mutations = {
  setModalContext(state, modalContext = {}) {
    state.modalContext = modalContext;
  },

  setAdditionalProperties(state, additionalProperties = {}) {
    state.modalContext.additionalProperties = additionalProperties;
  },
};

export const actions = {
  updateModalContext({ commit }, modalContext = {}) {
    commit('setModalContext', modalContext);
  },

  updateAdditionalProperties({ commit }, additionalProperties = {}) {
    commit('setAdditionalProperties', additionalProperties);
  },

  clearModalContext({ dispatch }) {
    dispatch('updateModalContext', initialState.modalContext);
  },
};

export const getters = {
  modalBeingShown: ({ modalContext }) => modalContext.modalBeingShown,
  auctionId: ({ modalContext }) => modalContext.auctionId,
  myAcvModule: ({ modalContext }) => modalContext.moduleKey,
  originPoint: ({ modalContext }) => modalContext.originPoint,
  additionalProperties: ({ modalContext }) => modalContext.additionalProperties,
};

const commonAuctionModals = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default commonAuctionModals;
